// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["blocks/before-after-slider/style-index","blocks/pricing-table/style-index"], () => (__webpack_require__("./src/blocks/pricing-table/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
